import { ff } from '@atlassian/jira-feature-flagging';
import uiVirtualAgentIntentTemplatesQuery from '@atlassian/jira-relay/src/__generated__/uiVirtualAgentIntentTemplatesQuery$parameters';
import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

type EntryPointParams = {
	cloudId: string;
	key: string;
};

export const virtualAgentCreateIntentTemplateSidebarEntryPoint = createEntryPoint({
	root: JSResourceForInteraction(
		() =>
			import(
				/* webpackChunkName: "async-virtual-agent-create-intent-templates-sidebar" */ './src/ui'
			),
	),
	getPreloadProps: ({ cloudId, key }: EntryPointParams) => ({
		queries: {
			intentTemplateQueryReference: {
				options: {
					fetchPolicy: 'store-or-network' as const,
				},
				parameters: uiVirtualAgentIntentTemplatesQuery,
				variables: {
					cloudId,
					key,
					isGateIntentTemplatesBehindAiToggleEnabled: ff(
						'activate-ai-toggle-message-in-intent-templates-sidebar_9dhqx',
					),
					isDiscoveredTemplatesTimestampEnabled: ff(
						'add-last-updated-timestamp-for-intent-templates_tgonx',
					),
				},
			},
		},
		entryPoints: {},
		extraProps: {},
	}),
});
